const middleware = {}

middleware['auth'] = require('../middleware/auth.js')
middleware['auth'] = middleware['auth'].default || middleware['auth']

middleware['auth/access/onboarding'] = require('../middleware/auth/access/onboarding.js')
middleware['auth/access/onboarding'] = middleware['auth/access/onboarding'].default || middleware['auth/access/onboarding']

middleware['auth/access/organization'] = require('../middleware/auth/access/organization.js')
middleware['auth/access/organization'] = middleware['auth/access/organization'].default || middleware['auth/access/organization']

middleware['auth/roles/is-admin'] = require('../middleware/auth/roles/is-admin.js')
middleware['auth/roles/is-admin'] = middleware['auth/roles/is-admin'].default || middleware['auth/roles/is-admin']

middleware['auth/roles/is-client'] = require('../middleware/auth/roles/is-client.js')
middleware['auth/roles/is-client'] = middleware['auth/roles/is-client'].default || middleware['auth/roles/is-client']

middleware['auth/roles/is-emp'] = require('../middleware/auth/roles/is-emp.js')
middleware['auth/roles/is-emp'] = middleware['auth/roles/is-emp'].default || middleware['auth/roles/is-emp']

middleware['employee-schedule-enabled'] = require('../middleware/employee-schedule-enabled.js')
middleware['employee-schedule-enabled'] = middleware['employee-schedule-enabled'].default || middleware['employee-schedule-enabled']

middleware['integrations-enabled'] = require('../middleware/integrations-enabled.js')
middleware['integrations-enabled'] = middleware['integrations-enabled'].default || middleware['integrations-enabled']

export default middleware
